export default {
  sm: `
  NAVER would like to fulfill 
  the role of a guardian to 
  preserve data and pass it 
  on to the next generations. 
  NAVER Data center will 
  preserve the national culture 
  and provide a new
  opportunity and a milestone 
  for the 21st century. 
  `,
  md: `
  NAVER would like to fulfill the role of a guardian 
  to preserve data and pass it on to the next 
  generations. NAVER Data center will preserve the 
  national culture and provide a new opportunity
  and a milestone for the 21st century. 
  `,
  lg: `
  NAVER would like to fulfill the role of a guardian to preserve 
  data and pass it on to the next generations. NAVER Data center will 
  preserve the national culture and provide a new opportunity
  and a milestone for the 21st century. 
  `,
  xxl: `
  NAVER would like to fulfill the role of a guardian to preserve 
  data and pass it on to the next generations. NAVER Data center 
  will preserve the national culture and provide a new opportunity
  and a milestone for the 21st century. 
  `,
};
